import type { SVGProps } from 'react';

const IconChevronLeftOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M9.79998 4.46999C9.53998 4.20999 9.11998 4.20999 8.85998 4.46999L5.79998 7.52999C5.53998 7.78999 5.53998 8.20999 5.79998 8.46999L8.85998 11.53C9.11998 11.79 9.53998 11.79 9.79998 11.53C10.06 11.27 10.06 10.85 9.79998 10.59L7.21331 7.99666L9.79998 5.40999C10.06 5.14999 10.0533 4.72333 9.79998 4.46999Z" />
  </svg>
);

export default IconChevronLeftOutline;
